export type * from './quick-editor-core';
export type { QuickEditorOptions } from './quick-editor';

export { default as GravatarQuickEditor } from './quick-editor';
export { GravatarQuickEditorCore } from './quick-editor-core';
